<template>
  <div>
    <Header />

    <div v-if="loading" class="content-web container mt-5 mb-5 ip-detail">
      <div class="text-center" style="width: 100%; padding-top: 50px;">
        <div class="spinner-border text-dark" role="status">
          <span class="sr-only">Đang tải...</span>
        </div>
      </div>
    </div>
    <div v-else class="content-web ">
      <div class="container mt-5 mb-5 ip-detail">
        <div class="row">
          <div class="col-12 cttv">
            <div class="title">
              <span class="info">{{ idea.companyName }}</span>
              <span class="info">{{ idea.type | GetTypeName }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="ip-detail-top clearfix">
              <div class="row">
                <div class="col-sm-12 col-md-8 col-lg-8 d-flex mb-3">
                  <div class="author-info">
                    <div class="name row">
                      <div class="col-12">
                        <h2 style="cursor: pointer; word-break: break-word;">
                          {{ idea.title }}
                        </h2>
                      </div>
                    </div>
                    <div class="author-info-btm row mt-2">
                      <div class="col-12">
                        <strong class="mr-1">Trạng thái:</strong>
                        {{ idea.statusName | UpperCase }}
                        <br />
                        <strong class="mr-1">Tác giả/Nhóm tác giả:</strong>
                        {{ idea.author }}
                        <div>
                          <strong class="mr-1">Liên hệ:</strong>
                          {{ idea.contactName }}
                          &nbsp;&nbsp;
                          <strong class="mr-1">SĐT:</strong>
                          {{ idea.contactPhone }}
                          &nbsp;&nbsp;
                          <strong class="mr-1">Email:</strong>
                          {{ idea.contactEmail }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 d-flex ip-count mb-3">
                  <div class="medal">
                    <div>iKHIEN</div>
                    <img :src="getImageMedal(idea)" />
                  </div>
                  <div class="views">
                    <div>VIEWS</div>
                    <span class="count">{{ idea.totalView || 0 }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2" v-if="ideaActions && ideaActions.length > 0">
          <div class="col-12">
            <div class="ip-detail-top clearfix">
              <div class="row">
                <div class="col-12">
                  <button
                    class="btn btn-info ml-2"
                    v-for="(action, index) in ideaActions"
                    @click="processIdea(action.action)"
                    :ref="action.action"
                    :id="'idea_action_' + action.action"
                    v-bind:key="index"
                  >
                    {{ action.actionName }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container mt-5 mb-5 content-detail">
        <div class="row">
          <div class="col-12">
            <vue-tabs>
              <v-tab title="Overview">
                <div class="tab-body introduction mt-3">
                  <div class="title">THÔNG TIN TỔNG QUÁT</div>

                  <div class="sub-title">
                    Giới thiệu về sáng kiến:
                    <p v-html="breakNewLine(idea.intro)"></p>
                  </div>
                  <div class="sub-title">
                    Đơn vị:
                    <p>{{ idea.companyUnit }}</p>
                  </div>
                  <div class="sub-title">
                    Phòng/ban:
                    <p>{{ idea.companyDepartment }}</p>
                  </div>
                  <div class="sub-title">
                    Thời điểm áp dụng thực tế:
                    <p>{{ idea.applyDate | FormatDateTime }}</p>
                  </div>
                </div>
                <div class="tab-body introduction">
                  <div class="title">NỘI DUNG SÁNG KIẾN</div>
                  <div class="sub-title">
                    Tình trạng trước khi có sáng kiến:
                    <p v-html="breakNewLine(idea.statusBefore)"></p>
                  </div>
                  <div class="sub-title">
                    Mục đích của giải pháp:
                    <p v-html="breakNewLine(idea.solutionPurpose)"></p>
                  </div>
                  <div class="sub-title">
                    Nội dung giải pháp đề nghị công nhận sáng kiến:
                    <p v-html="breakNewLine(idea.ideaSuggestApplyContent)"></p>
                  </div>
                </div>
                <div class="tab-body introduction">
                  <div class="title">PHÂN TÍCH SÁNG KIẾN</div>
                  <div class="sub-title">
                    Tính hiệu quả:
                    <p v-html="breakNewLine(idea.effective)"></p>
                  </div>
                  <div class="sub-title">
                    Tính mới:
                    <p v-html="breakNewLine(idea.novelty)"></p>
                  </div>
                  <div class="sub-title">
                    Tính sáng tạo:
                    <p v-html="breakNewLine(idea.creativity)"></p>
                  </div>
                  <div class="sub-title">
                    Dự định tiếp theo:
                    <p v-html="breakNewLine(idea.nextPlan)"></p>
                  </div>
                </div>
                <div class="tab-body introduction">
                  <div class="title">THÔNG TIN KHÁC</div>
                  <div class="sub-title">
                    Các thông tin cần được bảo mật:
                    <p v-html="breakNewLine(idea.securityContent)"></p>
                  </div>
                  <div class="sub-title">
                    Các điều kiện cần thiết để áp dụng sáng kiến:
                    <p v-html="breakNewLine(idea.ideaCondition)"></p>
                  </div>
                  <div class="sub-title">File đính kèm:</div>
                  <div
                    v-if="attachmentDetail && attachmentDetail.length"
                    class="content"
                  >
                    <a
                      href="javascript:void(0)"
                      v-for="file in attachmentDetail"
                      :key="file.id"
                      class="badge badge-attachment"
                      style="margin-right: 20px;"
                      @click="downloadAttachment(file, idea.id)"
                      >{{ file.fileName }}</a
                    >
                  </div>
                  <div class="content" v-else>
                    Không có dữ liệu tại thời điểm này!
                  </div>
                </div>

                <div class="tab-body introduction">
                  <div class="title">SLIDESHOW</div>
                  <div v-if="idea.slideShow">
                    <VueSlickCarousel height="200px">
                      <img
                        v-for="thumbnail in getSlideShows()"
                        :key="thumbnail"
                        :src="apiUrl + '/image/' + thumbnail"
                      />
                    </VueSlickCarousel>
                  </div>
                </div>
              </v-tab>
              <v-tab title="Tài liệu thuyết trình" id="presentDocuments">
                <div class="tab-body introduction mt-3">
                  <div class="title">
                    TÀI LIỆU PHỤC VỤ CHO VIỆC THUYẾT TRÌNH
                  </div>

                  <div class="sub-title">File đính kèm:</div>
                  <div
                    v-if="idea.presentDocuments && idea.presentDocuments.length"
                    class="content"
                  >
                    <a
                      href="javascript:void(0)"
                      v-for="file in idea.presentDocuments"
                      :key="file.id"
                      class="badge badge-attachment"
                      style="margin-right: 20px;"
                      @click="downloadAttachment(file, idea.id)"
                      >{{ file.fileName }}</a
                    >
                  </div>
                  <div class="content" v-else>
                    Không có dữ liệu tại thời điểm này!
                  </div>
                </div>
              </v-tab>
            </vue-tabs>
          </div>
        </div>
      </div>

      <b-modal ref="preliminaryExaminationModal" hide-footer title="Sơ loại">
        <div class="d-block">
          <validation-observer ref="formPreExam">
            <form>
              <div class="form-group">
                <label class="required">Kết quả sơ loại</label>
                <div class="radio-inline">
                  <input
                    id="preExamApproved"
                    type="radio"
                    :value="'approved'"
                    v-model="preExamForm.action"
                    @click="$refs.formPreExam.reset()"
                  />
                  <label for="preExamApproved">Hồ sơ đáp ứng yêu cầu</label>
                  <input
                    class="ml-4"
                    id="preExamRequestUpdate"
                    type="radio"
                    :value="'request_update'"
                    v-model="preExamForm.action"
                    @click="$refs.formPreExam.reset()"
                  />
                  <label for="preExamRequestUpdate">Yêu cầu cập nhật </label>
                  <input
                    class="ml-4"
                    id="preExamReject"
                    type="radio"
                    :value="'reject'"
                    v-model="preExamForm.action"
                    @click="$refs.formPreExam.reset()"
                  />
                  <label for="preExamReject">Từ chối </label>
                </div>
              </div>
              <div
                v-if="
                  preExamForm.action === 'request_update' ||
                    preExamForm.action === 'reject'
                "
              >
                <validation-provider
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <b-form-group
                    class="form-group"
                    label-for="preExamRejectReason"
                  >
                    <template slot="label">
                      Lí do
                      <span class="text-danger font-italic note">*</span>
                    </template>
                    <b-form-textarea
                      id="preExamRejectReason"
                      class="form-control"
                      v-model="preExamForm.rejectReason"
                      :state="getValidationState(validationContext)"
                    ></b-form-textarea>
                    <b-form-invalid-feedback id="input-name">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
            </form>
          </validation-observer>
        </div>
        <div style="float: right;">
          <button
            class="btn btn-info mr-2"
            @click="processIdea('preliminary_examination', 'submit')"
          >
            Gửi
          </button>
          <button
            class="btn btn-secondary"
            @click="processIdea('preliminary_examination', 'close')"
          >
            Đóng
          </button>
        </div>
      </b-modal>
      <b-modal ref="approveIdeaModal" hide-footer title="Duyệt sáng kiến">
        <div class="d-block">
          <validation-observer ref="formApproveIdea">
            <form>
              <div class="form-group">
                <label class="required">Công nhận sáng kiến</label>
                <div class="radio-inline">
                  <input
                    id="notApprove"
                    type="radio"
                    :value="false"
                    v-model="approveIdeaForm.ideaApproved"
                    @click="$refs.formApproveIdea.reset()"
                  />
                  <label for="notApprove">Không công nhận</label>
                  <input
                    class="ml-4"
                    id="approve"
                    type="radio"
                    :value="true"
                    v-model="approveIdeaForm.ideaApproved"
                    @click="$refs.formApproveIdea.reset()"
                  />
                  <label for="approve">Công nhận</label>
                </div>
              </div>
              <div v-if="approveIdeaForm.ideaApproved">
                <validation-provider
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <div class="form-group">
                    <label class="required" for="cboEffectiveType"
                      >Loại hiệu quả</label
                    >
                    <b-form-select
                      v-model="approveIdeaForm.effectiveType"
                      :options="effectiveTypes"
                      value-field="code"
                      text-field="name"
                      :disabled="!approveIdeaForm.ideaApproved"
                      :state="getValidationState(validationContext)"
                    ></b-form-select>
                    <b-form-invalid-feedback id="input-companyCode">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </div>
                </validation-provider>

                <validation-provider
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <b-form-group
                    class="form-group"
                    label-for="txtEffectiveEstimate"
                  >
                    <template slot="label">
                      Giá trị làm lợi (VND)
                      <span class="text-danger font-italic note">*</span>
                    </template>
                    <b-form-input
                      id="txtEffectiveEstimate"
                      name="input-name"
                      type="text"
                      class="form-control"
                      v-model="approveIdeaForm.effectiveEstimate"
                      :disabled="!approveIdeaForm.ideaApproved"
                      :state="getValidationState(validationContext)"
                      :formatter="formatter"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-name">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <validation-provider
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <b-form-group class="form-group" label-for="txtBonusMoney">
                    <template slot="label">
                      Thưởng khuyến khích của công ty (VND)
                      <span class="text-danger font-italic note">*</span>
                    </template>
                    <b-form-input
                      class="form-control"
                      id="txtBonusMoney"
                      v-model="approveIdeaForm.bonusMoney"
                      :disabled="!approveIdeaForm.ideaApproved"
                      :state="getValidationState(validationContext)"
                      :formatter="formatter"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-name">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group
                    class="form-group"
                    label-for="txtGroupBonusMoney"
                  >
                    <template slot="label">
                      Thưởng theo chính sách của tập đoàn (VND)
                      <span class="text-danger font-italic note">*</span>
                    </template>
                    <b-form-input
                      class="form-control"
                      id="txtGroupBonusMoney"
                      v-model="approveIdeaForm.groupBonusMoney"
                      :disabled="!approveIdeaForm.ideaApproved"
                      :state="getValidationState(validationContext)"
                      :formatter="formatter"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-name">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
              <div v-if="!approveIdeaForm.ideaApproved">
                <validation-provider
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <b-form-group
                    class="form-group"
                    label-for="txtApproveRejectReason"
                  >
                    <template slot="label">
                      Lí do
                      <span class="text-danger font-italic note">*</span>
                    </template>
                    <b-form-textarea
                      id="txtApproveRejectReason"
                      class="form-control"
                      v-model="approveIdeaForm.rejectReason"
                      :state="getValidationState(validationContext)"
                    ></b-form-textarea>
                    <b-form-invalid-feedback id="input-name">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
            </form>
          </validation-observer>
        </div>
        <div style="float: right;">
          <button
            class="btn btn-info mr-2"
            @click="processIdea('approve', 'submit')"
          >
            Gửi
          </button>
          <button
            class="btn btn-secondary"
            @click="processIdea('approve', 'close')"
          >
            Đóng
          </button>
        </div>
      </b-modal>

      <b-modal
        ref="updateApproveIdeaModal"
        hide-footer
        title="Cập nhật/Bổ sung mức thưởng"
      >
        <div class="d-block">
          <validation-observer ref="formUpdateApproveIdea">
            <form>
              <div>
                <validation-provider
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <div class="form-group">
                    <label class="required" for="cboEffectiveType"
                      >Loại hiệu quả</label
                    >
                    <b-form-select
                      v-model="updateApproveIdeaForm.effectiveType"
                      :options="effectiveTypes"
                      value-field="code"
                      text-field="name"
                      :state="getValidationState(validationContext)"
                    ></b-form-select>
                    <b-form-invalid-feedback id="input-companyCode">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </div>
                </validation-provider>

                <validation-provider
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <b-form-group
                    class="form-group"
                    label-for="txtEffectiveEstimate"
                  >
                    <template slot="label">
                      Giá trị làm lợi (VND)
                      <span class="text-danger font-italic note">*</span>
                    </template>
                    <b-form-input
                      id="txtEffectiveEstimate"
                      name="input-name"
                      type="text"
                      class="form-control"
                      v-model="updateApproveIdeaForm.effectiveEstimate"
                      :state="getValidationState(validationContext)"
                      :formatter="formatter"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-name">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <validation-provider
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                  <b-form-group class="form-group" label-for="txtBonusMoney">
                    <template slot="label">
                      Thưởng khuyến khích của công ty (VND)
                      <span class="text-danger font-italic note">*</span>
                    </template>
                    <b-form-input
                      class="form-control"
                      id="txtBonusMoney"
                      v-model="updateApproveIdeaForm.bonusMoney"
                      :state="getValidationState(validationContext)"
                      :formatter="formatter"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-name">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group
                    class="form-group"
                    label-for="txtGroupBonusMoney"
                  >
                    <template slot="label">
                      Thưởng theo chính sách của tập đoàn (VND)
                      <span class="text-danger font-italic note">*</span>
                    </template>
                    <b-form-input
                      class="form-control"
                      id="txtGroupBonusMoney"
                      v-model="updateApproveIdeaForm.groupBonusMoney"
                      :state="getValidationState(validationContext)"
                      :formatter="formatter"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-name">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>
            </form>
          </validation-observer>
        </div>
        <div style="float: right;">
          <button
            class="btn btn-info mr-2"
            @click="processIdea('add_bonus', 'submit')"
          >
            Gửi
          </button>
          <button
            class="btn btn-secondary"
            @click="processIdea('add_bonus', 'close')"
          >
            Đóng
          </button>
        </div>
      </b-modal>

      <!-- delete Idea -->
      <b-modal ref="deleteIdeaModal" hide-footer title="Xóa sáng kiến">
        <div class="modal-body">Bạn có chắc muốn xóa sáng kiến này?</div>
        <div style="float: right;">
          <button
            class="btn btn-info mr-2"
            @click="processIdea('remove_idea', 'submit')"
          >
            Đồng ý
          </button>
          <button
            class="btn btn-secondary"
            @click="processIdea('remove_idea', 'close')"
          >
            Hủy
          </button>
        </div>
      </b-modal>

      <b-modal
        ref="chooseToContest"
        hide-footer
        title="Chọn vào chung khảo tháng"
      >
        <div class="d-block">
          <validation-observer ref="formChooseToContest">
            <form>
              <validation-provider
                :rules="{ required: true }"
                v-slot="validationContext"
              >
                <div class="form-group">
                  <label class="required">Tháng</label>
                  <b-form-select
                    v-model="ideaPeriodForm.periodCode"
                    :options="listPeriod"
                    value-field="code"
                    text-field="name"
                    :state="getValidationState(validationContext)"
                  ></b-form-select>
                  <b-form-invalid-feedback id="input-companyCode">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </div>
              </validation-provider>

              <validation-provider
                :rules="{ required: true }"
                v-slot="validationContext"
              >
                <div class="form-group">
                  <label class="required">Bảng</label>
                  <b-form-select
                    v-model="ideaPeriodForm.periodTable"
                    :options="listTable"
                    value-field="value"
                    text-field="value"
                    :state="getValidationState(validationContext)"
                  ></b-form-select>
                  <b-form-invalid-feedback id="input-companyCode">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </div>
              </validation-provider>
            </form>
          </validation-observer>
        </div>
        <div style="float: right;">
          <button
            class="btn btn-info mr-2"
            @click="processIdea('add_to_period', 'submit')"
          >
            Gửi
          </button>
          <button
            class="btn btn-secondary"
            @click="processIdea('add_to_period', 'close')"
          >
            Đóng
          </button>
        </div>
      </b-modal>

      <b-modal ref="yearRewardModal" hide-footer title="Cập nhật danh hiệu năm">
        <div class="d-block">
          <validation-observer ref="formYearRewardModal">
            <form>
              <validation-provider
                :rules="{ required: true }"
                v-slot="validationContext"
              >
                <div class="form-group">
                  <label class="required">Danh hiệu</label>
                  <b-form-select
                    v-model="yearRewardForm.level"
                    :options="[
                      { code: 1, name: 'Sáng tạo của năm' },
                      { code: 2, name: 'Giải nhì năm' }
                    ]"
                    value-field="code"
                    text-field="name"
                    :state="getValidationState(validationContext)"
                  ></b-form-select>
                  <b-form-invalid-feedback id="input-companyCode">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </div>
              </validation-provider>
            </form>
          </validation-observer>
        </div>
        <div style="float: right;">
          <button
            class="btn btn-info mr-2"
            @click="processIdea('update_year_reward', 'submit')"
          >
            Gửi
          </button>
          <button
            class="btn btn-secondary"
            @click="processIdea('update_year_reward', 'close')"
          >
            Đóng
          </button>
        </div>
      </b-modal>

      <b-modal ref="scoreIdea" hide-footer title="Chấm điểm sáng kiến">
        <div class="d-block">
          <validation-observer ref="formScoreIdea">
            <form>
              <validation-provider
                :rules="{ required: true }"
                v-slot="validationContext"
              >
                <div class="form-group">
                  <label class="required">Danh hiệu</label>
                  <b-form-select
                    v-model="ideaScoringForm.medal"
                    :options="listMedal"
                    value-field="code"
                    text-field="name"
                    :state="getValidationState(validationContext)"
                  ></b-form-select>
                  <b-form-invalid-feedback id="input-companyCode">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </div>
              </validation-provider>

              <!--<validation-provider :rules="{ required: true}" v-slot="validationContext">
                <div class="form-group">
                  <label class="required">Nhận xét</label>
                  <b-form-textarea
                    class="form-control"
                    v-model="ideaScoringForm.comment"
                    :state="getValidationState(validationContext)"
                  ></b-form-textarea>
                  <b-form-invalid-feedback id="input-required">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </div>
              </validation-provider>-->
            </form>
          </validation-observer>
        </div>
        <div style="float: right;">
          <button
            class="btn btn-info mr-2"
            @click="processIdea('score', 'submit')"
          >
            Gửi
          </button>
          <button
            class="btn btn-secondary"
            @click="processIdea('score', 'close')"
          >
            Đóng
          </button>
        </div>
      </b-modal>

      <b-modal
        ref="attachPresentDocumentModal"
        hide-footer
        title="Bổ sung tài liệu thuyết trình"
        size="xl"
      >
        <div class="d-block">
          <div class="col-12">
            <vue-dropzone
              style="border: 1px dashed #1ab394"
              id="fileDocument"
              :destroyDropzone="false"
              :options="optionsUploadDocument"
              :useCustomSlot="true"
              ref="fileDocument"
              @vdropzone-success="onUploadDocumentSuccess"
              @vdropzone-removed-file="onRemoveDocument"
            >
              <div class="dropzone-custom-content">
                <h4 class="dropzone-custom-title">Chọn file.</h4>
              </div>
            </vue-dropzone>
          </div>
        </div>
        <div style="float: right;" class="mt-2">
          <button
            class="btn btn-info mr-2"
            @click="processIdea('attach_present_document', 'submit')"
          >
            Gửi
          </button>
          <button
            class="btn btn-secondary"
            @click="processIdea('attach_present_document', 'close')"
          >
            Đóng
          </button>
        </div>
      </b-modal>
      <b-modal ref="ideaRemoveFromPeriodModal" hide-footer title="Cảnh báo">
        <div class="d-block">
          <div class="col-12">
            Bạn có chắc chắn muốn gỡ sáng kiến này khỏi cuộc thi chung khảo
            tháng?
          </div>
        </div>
        <div style="float: right;" class="mt-2">
          <button
            class="btn btn-info mr-2"
            @click="processIdea('remove_idea_from_period', 'submit')"
          >
            Gửi
          </button>
          <button
            class="btn btn-secondary"
            @click="processIdea('remove_idea_from_period', 'close')"
          >
            Đóng
          </button>
        </div>
      </b-modal>
    </div>

    <Footer />
  </div>
</template>

<script>
import 'vue-nav-tabs/themes/vue-tabs.css';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import { VTab, VueTabs } from 'vue-nav-tabs';
import axios from 'axios';
import VueSlickCarousel from 'vue-slick-carousel';
import vue2Dropzone from 'vue2-dropzone';
import * as CONFIG from '../../config/index';

import CommentList from '@/components/common/CommentList';
import ideaCommon from '../../common/idea';
import ideaWorkflowCommon from '../../common/ideaWorkflow';
import masterDataCommon from '../../common/masterData';
import { ipType } from '../const/ipType';
import { getFileInfoList, removeFile } from '../../common/file';
import moment from 'moment';
import periodCommon from '../../common/period';
import ideaScoringCommon from '../../common/ideaScoring';
import helper from '../../common/helper';
import Vue from 'vue';

export const DOWNLOAD_FILE_API_URL = `${CONFIG.API_URL}/file/download`;

const handleIPError = function(error) {
  if (error.response.status === 403) {
    window.location.href = `${CONFIG.CLIENT_URL}/#/not-found`;
  }
};

const getAuthHeader = () => {
  let token = Vue.$cookies.get('accessToken');
  return { Authorization: `Bearer ${token}` };
};

export default {
  name: 'IPViewAdmin',
  components: {
    Header,
    Footer,
    VueTabs,
    VTab,
    CommentList,
    VueSlickCarousel,
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      ipEditUrl: `${CONFIG.CLIENT_URL}/#/edit-submission`,
      apiUrl: CONFIG.API_URL,
      idea: {},
      loading: false,
      ideaActions: [],
      requestUpdateForm: {},
      approveIdeaForm: {
        ideaApproved: false,
        effectiveType: '',
        effectiveEstimate: '',
        bonusMoney: '',
        groupBonusMoney: '',
        rejectReason: ''
      },
      updateApproveIdeaForm: {
        ideaApproved: true,
        effectiveType: '',
        effectiveEstimate: '',
        bonusMoney: '',
        groupBonusMoney: ''
      },
      preExamForm: {
        action: '',
        ideaId: '',
        rejectReason: ''
      },
      effectiveTypes: [],
      attachmentDetail: null,
      listPeriod: [],
      listTable: [
        {
          key: 'tableA',
          value: 'Bảng A'
        },
        {
          key: 'tableB',
          value: 'Bảng B'
        }
      ],
      ideaPeriodForm: {
        periodCode: null,
        periodTable: null
      },
      ideaScoringForm: {
        medal: null
      },
      listMedal: [],
      scoreExist: false,
      yearRewardForm: {
        id: null,
        level: 1
      },
      optionsUploadDocument: {
        url: `${CONFIG.API_URL}/file/upload?type=tbl_content`,
        thumbnailWidth: 150,
        maxFilesize: 100,
        addRemoveLinks: true,
        headers: getAuthHeader()
      },
      documentId: '',
      documentFiles: [],
      updateDocumentForm: {}
    };
  },
  filters: {
    UpperCase(string) {
      if (string) {
        return string.toUpperCase();
      }
    },
    GetTypeName(code) {
      if (!code) {
        return '';
      }
      const typeData = ipType.find(p => p.code === code);
      if (typeData) {
        return typeData.name;
      }
      return '';
    },
    FormatDateTime: function(time) {
      if (time != null) {
        return moment(time).format('YYYY-MM-DD');
      }
      return '';
    }
  },
  async mounted() {
    this.loading = true;
    this.idea = await ideaCommon.getIdea(this.$route.params.id);

    await this.getAttachments();
    this.getSlideShows();
    this.loading = false;
    this.ideaActions = await ideaWorkflowCommon.getAction(this.idea.status);
    this.effectiveTypes = await masterDataCommon.sync.getByType(
      'effective_type'
    );
    const periodRes = await periodCommon.search('', 1, 1000, true);
    this.listPeriod = periodRes.items;
    this.listMedal = [
      { code: 'gold', name: 'Vàng' },
      { code: 'silver', name: 'Bạc' },
      { code: 'bronze', name: 'Đồng' },
      { code: 'consolation', name: 'Khuyến khích' }
    ];
    this.scoreExist = await ideaScoringCommon.checkExist(this.idea.id);
    if (this.scoreExist) {
      //this.$refs.score.setAttribute('disabled', 'true');
      if (document.getElementById('idea_action_score')) {
        document.getElementById('idea_action_score').disabled = true;
      }
    }
    if (this.idea.medal !== 'gold') {
      if (document.getElementById('idea_action_update_year_reward')) {
        document.getElementById(
          'idea_action_update_year_reward'
        ).disabled = true;
      }
    }
  },
  methods: {
    getImageLevel(ipLevel = 0) {
      // switch (ipLevel) {
      //   case 0:
      //     return require(`@/assets/images/0.svg`);
      // }
    },
    async getAllCompany() {
      try {
        let res = await axios.get(
          CONFIG.API_URL + '/company/search?pageNo=1&pageSize=1000'
        );
        return res.data.data.items;
      } catch (e) {
        console.error(e);
      }
    },
    async processIdea(action, subAction) {
      let submit = false;
      const form = {
        ideaId: this.idea.id,
        action: action,
        data: {}
      };
      let mesage = '';
      if ('preliminary_examination' === action) {
        if (!subAction) {
          this.$refs.preliminaryExaminationModal.show();
        } else {
          if (subAction === 'submit') {
            const validate = await this.$refs.formPreExam.validate();
            if (validate) {
              this.preExamForm.ideaId = this.idea.id;
              form.data = this.preExamForm;
              submit = true;
              mesage = 'Cập nhật sơ loại sáng kiến thành công';
            } else {
              return;
            }
          } else {
            this.closePreExamModal();
            return;
          }
          this.closePreExamModal();
        }
      } else if ('approve' === action) {
        if (!subAction) {
          this.$refs.approveIdeaModal.show();
        } else {
          if (subAction === 'submit') {
            // if (this.approveIdeaForm.ideaApproved) {
            let validate = await this.$refs.formApproveIdea.validate();
            console.log(validate);
            if (!validate) {
              return;
            }
            // }
            this.approveIdeaForm.ideaId = this.idea.id;
            form.data = { ...this.approveIdeaForm };
            if (this.approveIdeaForm.ideaApproved) {
              form.data.bonusMoney = this.approveIdeaForm.bonusMoney.replace(
                /[^\d]/g,
                ''
              );
              form.data.groupBonusMoney = this.approveIdeaForm.groupBonusMoney.replace(
                /[^\d]/g,
                ''
              );
              form.data.effectiveEstimate = this.approveIdeaForm.effectiveEstimate.replace(
                /[^\d]/g,
                ''
              );
            }
            submit = true;
            mesage = this.approveIdeaForm.ideaApproved
              ? 'Phê duyệt sáng kiến thành công'
              : 'Từ chối sáng kiến thành công';
          } else {
            this.approveIdeaForm = {
              ideaApproved: false,
              effectiveType: '',
              effectiveEstimate: '',
              bonusMoney: ''
            };
            this.closeApproveIdeaModal();
            return;
          }
        }
        this.closeApproveIdeaModal();
      } else if ('add_to_period' === action) {
        if (!subAction) {
          this.$refs.chooseToContest.show();
        } else {
          if (subAction === 'submit') {
            const validate = await this.$refs.formChooseToContest.validate();
            if (validate) {
              this.ideaPeriodForm.ideaId = this.idea.id;
              form.data = this.ideaPeriodForm;
              submit = true;
              mesage = 'Đã chọn chung khảo tháng thành công';
            } else {
              return;
            }
          } else {
            this.ideaPeriodForm = {
              periodCode: null,
              periodTable: null
            };
            this.$refs.chooseToContest.hide();
          }
        }
        this.$refs.chooseToContest.hide();
      } else if ('score' === action) {
        if (!subAction) {
          this.$refs.scoreIdea.show();
        } else {
          if (subAction === 'submit') {
            const validate = await this.$refs.formScoreIdea.validate();
            if (validate) {
              this.ideaScoringForm.ideaId = this.idea.id;
              form.data = this.ideaScoringForm;
              submit = true;
              mesage = 'Đã chấm điểm thành công';
            } else {
              return;
            }
          } else {
            this.ideaScoringForm = {
              medal: null
            };
            this.$refs.scoreIdea.hide();
          }
        }
        this.$refs.scoreIdea.hide();
      } else if ('update_year_reward' === action) {
        if (!subAction) {
          this.$refs.yearRewardModal.show();
        } else {
          if (subAction === 'submit') {
            const validate = await this.$refs.formYearRewardModal.validate();
            if (validate) {
              this.yearRewardForm.id = this.idea.id;
              form.data = this.yearRewardForm;
              submit = true;
              mesage = 'Cập nhật danh hiệu năm thành công';
            } else {
              return;
            }
          } else {
            this.yearRewardForm = {
              id: null,
              level: 1
            };
            this.$refs.yearRewardModal.hide();
          }
        }
        this.$refs.yearRewardModal.hide();
      } else if ('attach_present_document' === action) {
        if (!subAction) {
          this.$refs.attachPresentDocumentModal.show();
          setTimeout(() => this.setFileDocumnet(this.idea), 1);
        } else {
          if (subAction === 'submit') {
            this.updateDocumentForm.id = this.idea.id;
            this.updateDocumentForm.documents = this.documentId.split(',');
            form.data = this.updateDocumentForm;
            submit = true;
            mesage = 'Cập nhật tài liệu thành công';
          } else {
            this.updateDocumentForm = {};
            this.$refs.attachPresentDocumentModal.hide();
          }
        }
        this.$refs.attachPresentDocumentModal.hide();
      } else if ('remove_idea_from_period' === action) {
        if (!subAction) {
          this.$refs.ideaRemoveFromPeriodModal.show();
        } else {
          if (subAction === 'submit') {
            submit = true;
            mesage = 'Gỡ thành công';
          } else {
            this.$refs.ideaRemoveFromPeriodModal.hide();
          }
        }
        this.$refs.ideaRemoveFromPeriodModal.hide();
      } else if ('add_bonus' == action) {
        if (!subAction) {
          this.axios
            .get(`${CONFIG.API_URL}/idea/bonus-detail/` + this.idea.id)
            .then(resBonus => {
              this.updateApproveIdeaForm.ideaApproved =
                resBonus.data.data.ideaApproved;
              this.updateApproveIdeaForm.effectiveType =
                resBonus.data.data.effectiveType;
              this.updateApproveIdeaForm.effectiveEstimate = this.formatter(
                resBonus.data.data.effectiveEstimate
              );
              this.updateApproveIdeaForm.bonusMoney = this.formatter(
                resBonus.data.data.bonusMoney.toString()
              );
              this.updateApproveIdeaForm.groupBonusMoney = this.formatter(
                resBonus.data.data.groupBonusMoney.toString()
              );
            })
            .catch(e => {});
          this.$refs.updateApproveIdeaModal.show();
        } else {
          if (subAction === 'submit') {
            let validate = await this.$refs.formUpdateApproveIdea.validate();
            console.log(validate);
            if (!validate) {
              return;
            }
            this.updateApproveIdeaForm.ideaId = this.idea.id;
            form.data = { ...this.updateApproveIdeaForm };

            if (this.updateApproveIdeaForm.ideaApproved) {
              form.data.bonusMoney = this.updateApproveIdeaForm.bonusMoney.replace(
                /[^\d]/g,
                ''
              );
              form.data.groupBonusMoney = this.updateApproveIdeaForm.groupBonusMoney.replace(
                /[^\d]/g,
                ''
              );
              form.data.effectiveEstimate = this.updateApproveIdeaForm.effectiveEstimate.replace(
                /[^\d]/g,
                ''
              );
            }
            submit = true;
            mesage = 'Cập nhật/Bổ sung mức thưởng thành công';
          } else {
            this.updateApproveIdeaForm = {
              effectiveType: '',
              effectiveEstimate: '',
              bonusMoney: ''
            };
            this.closeUpdateApproveIdeaModal();
            return;
          }
        }
        this.closeUpdateApproveIdeaModal();
      } else if ('remove_idea' == action) {
        if (!subAction) {
          this.$refs.deleteIdeaModal.show();
        } else {
          if (subAction === 'submit') {
            mesage = 'Xóa sáng kiến thành công';
            await ideaCommon.deleteIdea(this.idea.id);
            window.location.href = `${CONFIG.CLIENT_URL}/#/review-submission`;
            helper.successMsg(mesage);
          } else {
            this.$refs.deleteIdeaModal.hide();
          }
        }
        this.$refs.deleteIdeaModal.hide();
      } else if ('update_info_idea' == action) {
        window.location.href = this.ipEditUrl + '/' + this.idea.id;
      }

      if (submit) {
        await ideaCommon.processIdea(form);
        this.idea = await ideaCommon.getIdea(this.idea.id);
        this.scoreExist = await ideaScoringCommon.checkExist(this.idea.id);
        if (this.scoreExist) {
          //this.$refs.score.setAttribute('disabled', 'true');
          if (document.getElementById('idea_action_score')) {
            document.getElementById('idea_action_score').disabled = true;
          }
        }
        if (this.idea) {
          helper.successMsg(mesage);
        }
        this.ideaActions = await ideaWorkflowCommon.getAction(this.idea.status);
      }
    },
    closePreExamModal() {
      this.preExamForm = {};
      this.$refs.preliminaryExaminationModal.hide();
    },
    closeApproveIdeaModal() {
      this.$refs.approveIdeaModal.hide();
      this.approveIdeaForm = {
        ideaApproved: false,
        effectiveType: '',
        effectiveEstimate: '',
        bonusMoney: ''
      };
    },
    closeUpdateApproveIdeaModal() {
      this.$refs.updateApproveIdeaModal.hide();
      this.updateApproveIdeaForm = {
        effectiveType: '',
        effectiveEstimate: '',
        bonusMoney: ''
      };
    },
    async getAttachments() {
      const { attachments } = this.idea;
      if (attachments) {
        this.attachmentDetail = await getFileInfoList(attachments);
      }
    },
    getSlideShows() {
      const { slideShow } = this.idea;
      if (slideShow) {
        return slideShow.split(',');
      }
      return [];
    },
    downloadAttachment(file, contentId) {
      this.axios
        .get(`${DOWNLOAD_FILE_API_URL}?id=${file.id}&contentId=${contentId}`, {
          responseType: 'blob'
        })
        .then(res => {
          const headers = res.headers;
          const blob = new Blob([res.data], { type: headers['content-type'] });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = file.fileName;
          link.click();
        })
        .catch(err => {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Bạn không có quyền tải về file này!'
          });
        });
    },
    getValidationState({ dirty, validated, valid = null }) {
      // console.log("getValidationState: dirty = " + dirty + ",validated =  " + validated + ", valid = " + valid)
      // console.log("dirty || validated ? valid " + dirty || validated ? valid : null)
      return dirty || validated ? valid : null;
    },
    onUploadDocumentSuccess(file, response) {
      this.$refs.fileDocument;
      if (!response || response.length <= 0) {
        return;
      }
      response.forEach(result => {
        this.documentFiles = [...this.documentFiles, { file, id: result.id }];
        const uploadedFile = result;
        if (uploadedFile) {
          const id = uploadedFile.id;
          let documents = this.documentId;
          if (documents) {
            documents += ',' + id;
          } else {
            documents += id;
          }
          this.documentId = documents;
        }
      });
    },
    onRemoveDocument(file, response, error, xhr) {
      if (file && file.id) {
        removeFile(file.id).then(resultRemove => {
          if (resultRemove.success) {
            let documents = this.documentId;
            const ids = documents.split(',');
            this.documentId = ids.filter(id => id != file.id).join(',');
          }
        });
        return;
      }
    },
    async setFileDocumnet(idea) {
      if (idea && idea.presentDocuments) {
        const idFiles = idea.presentDocuments.map(p => p.id);
        const idFileString = idFiles.join(',');
        this.documentId = idFileString;
        idea.presentDocuments &&
          idea.presentDocuments.forEach(file => {
            this.setFileDropzone(file);
          });
      }
    },
    setFileDropzone(file) {
      const fileInfor = this.convertFileInfo(file);
      if (this.checkFileIsImage(fileInfor)) {
        this.$refs.fileDocument.manuallyAddFile(
          fileInfor,
          this.getUrlImage(fileInfor)
        );
        this.$refs.fileDocument.dropzone.emit(
          'thumbnail',
          fileInfor,
          this.getUrlImage(fileInfor)
        );
        this.$refs.fileDocument.dropzone.emit('complete', fileInfor);
      } else {
        this.$refs.fileDocument.manuallyAddFile(fileInfor, '');
      }
    },
    checkFileIsImage(file) {
      if (file && file.type && file.type.match(/image\//)) {
        return true;
      }
      return false;
    },
    getUrlImage(file) {
      return `${CONFIG.API_URL}/image/${file.id}`;
    },
    convertFileInfo(file) {
      if (!file) {
        return;
      }
      return {
        id: file.id,
        size: file.fileSize,
        name: file.fileName,
        type: file.mimeType
      };
    },
    getImageMedal(idea) {
      try {
        if (!idea.medal && !idea.yearReward) {
          return '';
        }

        if (idea.yearReward) {
          return require(`@/assets/images/medals/${idea.yearReward}.png`);
        } else {
          return require(`@/assets/images/medals/${idea.medal}.png`);
        }
      } catch (error) {
        return '';
      }
    },
    formatter(value) {
      const currencyValue = value.replace(/[^\d]/g, '');
      return currencyValue.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
    },
    breakNewLine(content) {
      return helper.breakLine(content);
    }
  }
};
</script>

<style scoped>
.ip-detail {
  color: #676a6c;
}

.ip-type {
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.06px;
  text-align: left;
  display: inline-block;
}

.ip-description {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.39;
  letter-spacing: normal;
  text-align: left;
  color: #1e242f;
}

.content {
  overflow-wrap: break-word;
  max-width: 80vw;
}

.ip-detail-top {
  box-shadow: 0 16px 34px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  padding: 15px 0;
}

.author-info {
  margin: 5px 0 0 15px;
}

.author-info .name h2 {
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.06px;
  text-align: left;
  display: inline-block;
  color: #1e242f;
  font-size: 26px;
  margin: 0;
  font-weight: bold;
  color: #337ab7;
}

.vue-tabs {
  width: 100%;
}

.tab-body .title {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
  font-size: 14px;
}
.tab-body .sub-title {
  max-width: 100%;
  font-weight: 600;
  font-size: 14px;
}

.tab-body {
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.22;
  letter-spacing: normal;
  text-align: left;
  color: #1e242f;
}

.badge-list {
  display: flex;
  align-content: center;
}

.badge-item {
  font-size: 12px;
  font-weight: 650;
  padding: 5px 10px;
  margin-top: 2px;
  line-height: 1.6;
  border-radius: 2px;
  background-color: #d1dade;
  color: #5e5e5e;
  cursor: pointer;
}

.update-version-detail .date-update {
  width: 100%;
  height: 38px;
  font-size: 28px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: 0.14px;
  text-align: left;
  color: #1e242f;
  margin-top: 20px;
  margin-bottom: 10px;
}

.update-version-detail .content-update {
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.22;
  letter-spacing: normal;
  text-align: left;
  color: #1e242f;
  word-break: break-word;
}

.update-version-detail .version-update {
  font-size: 18px;
  color: #3199bb;
  font-weight: 600;
  letter-spacing: 0.14px;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  margin-top: 5px;
  cursor: pointer;
}

.tab-body p {
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.22;
  letter-spacing: normal;
  text-align: left;
  color: #1e242f;
  margin-left: 15px;
}
.ip-count > div > div {
  font-weight: bold;
  font-size: 16px;
  color: #1e242f;
}

.ip-count > div span.count {
  color: #3299ba;
  font-size: 28px;
  font-weight: 600;
}

.ip-count > div {
  margin: 0 7px;
}

.level img,
.views .count {
  margin: auto;
  display: block;
  text-align: center;
}

.cttv .title {
  color: #337ab7;
  font-weight: bold;
}

.cttv .info {
  color: #fff;
  background-color: #3199bb;
  border-radius: 5px;
  padding: 0 5px;
}

.slick-slider img {
  display: block;
  max-width: 100%;
  width: auto;
  height: auto;
  height: 450px;
}
.vue-dropzone {
  display: flex;
  justify-content: center;
  align-items: center;
}

.medal img,
.views .count {
  margin: auto;
  display: block;
  text-align: center;
}
.medal img {
  margin-top: 8px;
  width: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/IPViewAdmin.vue